// GET /api/ui/trader-management/clients/unassigned
// Lista klientow bez przypisanego handlowca (do wyszukiwarki w modalu).

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IUnassignedClientItem {
  clientId: number | null;
  clientName: string | null;
  taxNumber: string | null;
}

export interface IGetUnassignedClientsParams {
  searchKeyword?: string;
  limit?: number;
}

export interface IGetUnassignedClientsResponse {
  items: IUnassignedClientItem[];
}

const get = (params: IGetUnassignedClientsParams): Promise<IGetUnassignedClientsResponse> =>
  axios.get('/trader-management/clients/unassigned', { params });

export const useGetUnassignedClients = (
  params: IGetUnassignedClientsParams,
  options?: UseQueryOptions<IGetUnassignedClientsResponse, IError>,
) =>
  useQuery<IGetUnassignedClientsResponse, IError>(
    ['trader-management-unassigned-clients', params],
    () => get(params),
    {
      keepPreviousData: true,
      ...options,
    },
  );
